//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    path: {
      default: () => [
        { label: "Standard", path: { name: "SyllabusStyleDetails" } },
        {
          label: "Waltz",
          path: { name: "DanceDetails", params: { danceid: "Waltz" } },
        },
      ],
    },
  },
};
